import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Grid, Stack, SxProps, Theme, Typography } from '@mui/material';
import React from 'react';

import SurveillanceTimeline from '../../Surveillance/SurveillanceTimeline';
import i18n from 'FRONTEND/utils/i18n';


type PanelProps = {
  panelSx: SxProps<Theme>;
  accordionSummarySx: SxProps<Theme>;
};

export const TimelinePanel = ({ panelSx, accordionSummarySx }: PanelProps) => {
  return (
    <Stack spacing={1} className='panel panel-info' sx={panelSx}>
      <Accordion defaultExpanded disableGutters sx={{ boxShadow: 'none' }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={accordionSummarySx}
        >
          <Typography sx={{ fontSize: '18px' }}>{i18n._('Other surveillance data')}</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ py: 2 }}>
          <Grid container spacing={1}>
            <SurveillanceTimeline showOrigin />
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Stack>
  );
};
